import { render, staticRenderFns } from "./confirmdecvideoflow.vue?vue&type=template&id=67e9b3af&lang=pug&"
import script from "./confirmdecvideoflow.vue?vue&type=script&lang=js&"
export * from "./confirmdecvideoflow.vue?vue&type=script&lang=js&"
import style0 from "./confirmdecvideoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports